import { render, staticRenderFns } from "./quotationIcon.vue?vue&type=template&id=5475ee40&scoped=true"
import script from "./quotationIcon.vue?vue&type=script&lang=js"
export * from "./quotationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475ee40",
  null
  
)

export default component.exports